import { DialTarget } from './next-dial-target.state';
import { IBrickInstanceTargetingAction } from '../../utility/IBrickInstanceTargetingAction';

export class NextDialTargetChanged implements IBrickInstanceTargetingAction {
   public static readonly type = '[NextDialTarget] Next dial target changed';
   constructor(public dialTarget: string | DialTarget, public brickInstanceId) {}
}
